// 这个mock的数据是从社区拷贝的，最后的图片有点儿问题，不用管
export const markdownReaderContent = `# 0.726代码在最后的链接，这部分是EDA
## 导入数据相关包

\`\`\`python
import pandas as pd
import matplotlib.pyplot as plt
import seaborn as sns
plt.style.use('seaborn')
sns.set(font_scale=2)
\`\`\`
`;
